module.exports = __webpack_public_path__ + "5c1331c1b3183fe50d0fb82c02ef0752.png";